import React from 'react'

const QdrantIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#DC244C"/>
    <path d="M12 3.5L20 8V16L12 20.5L4 16V8L12 3.5Z" fill="white" fillOpacity="0.12"/>
    <path d="M12 3.5L20 8L12 12.5L4 8L12 3.5Z" fill="white" fillOpacity="0.3"/>
    <path d="M4 8V16L12 20.5V12.5L4 8Z" fill="white" fillOpacity="0.5"/>
    <path d="M20 8V16L12 20.5V12.5L20 8Z" fill="white" fillOpacity="0.7"/>
    <path d="M12 3.5L20 8L12 12.5L4 8L12 3.5Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.4"/>
    <path d="M4 8V16L12 20.5V12.5L4 8Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.4"/>
    <path d="M20 8V16L12 20.5V12.5L20 8Z" stroke="white" strokeOpacity="0.6" strokeWidth="0.4"/>
  </svg>
)

export default QdrantIcon
